<template lang="html">
	<div id="app">
    <div class="row">
      <div class="col-xs-12">
        <div class="sidebar">
          <button id="table_filter_save"
                  :title="$t('save')" @click="saveTableFilter">
            <span uk-icon="save"></span>
            <span class="title">{{ $t('save') }}</span>
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <div class="main demo">
          <div class="demo-content nested v-row">
            <div class="v-col--50">
              <div class="filter">
                <div class="new-elements">
                  <div class="panel panel--filter">
                    <div class="panel__heading">
                      <h3>{{ $t('elements.list') }}</h3>
                    </div>
                    <div class="panel__body">
                      <div class="filter-control">
                        <input type="text" class="input" placeholder="Search"
                               v-model="currentFilterValue">
                        <span class="clear"
                              @click="clearFilter">&times;</span>
                      </div>
                      <vddl-list class="panel__body--list"
                                 :list="filterData"
                                 :allowed-types="['list']"
                                 :horizontal="false">
                        <vddl-draggable class="panel__body--item" v-for="(item, index) in filterData"
                                        :key="item.id"
                                        :draggable="{ title: item.title, type: 'ATTRIBUTE' }"
                                        :index="index"
                                        :type="'itemList'"
                                        :wrapper="filterData"
                                        effect-allowed="move"
                                        :selected="handleSelected"
                                        :moved="handleMovedItemList"
                                        :class="{'selected': selectedItem === item.title}">
                          <span class="fa fa-ellipsis-v drag"></span> {{ item.localization ||
                        item.title }} <br><span>{{'{' + item.title + '}'}}</span>
                        </vddl-draggable>
                      </vddl-list>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="v-col--50">
              <div class="table-filter">
                <div class="panel">
                  <div class="panel__heading">
                    <h3>{{ $t('table.filter') }}</h3>
                  </div>
                  <div class="panel__body">
                    <div class="filter-control">
                      <input type="text" class="input" placeholder="Search"
                             v-model="currentFilterFilterValue">
                      <span class="clear"
                            @click="clearFilterFilter">&times;</span>
                    </div>
                    <vddl-list class="panel__body--list scroll_panel__body"
                               :list="filters"
                               :drop="handleDrop"
                               :moved="handleMovedFilter"
                               :allowed-types="['list', 'container', 'itemList']"
                               :external-sources="true">
                      <vddl-draggable class="panel__body--item"
                                      v-for="(filter, index) in filters"
                                      v-show="isFilterVisible(filter)"
                                      :key="index"
                                      :draggable="{ title: filter, type: 'FILTER' }"
                                      :index="index"
                                      :wrapper="filters"
                                      :type="'list'"
                                      effect-allowed="move"
                                      :moved="handleMovedFilter">
                        <span class="fa fa-ellipsis-v drag"></span>
                        {{ getFilterLocalization(filter) }} <br><span>{{'{' + filter + '}'}}</span>
                        <span class="fa fa-trash delete-icon" @click="handleDeleteFilter(filter)"></span>
                      </vddl-draggable>
                    </vddl-list>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
	</div>
</template>

<script>
import { arrayKey, removeAttributeId } from '@/services/shared'
import { CONFIGURATIONS_ITEM_STRUCTURE } from 'actions/configurations'
import { saveAttributes } from '@/core/shared'

export default {
	name: 'TableFilter',
	metaInfo () {
		return {
			title: this.$t('table.filter')
		}
	},
	data () {
		return {
			selectedItem: {
				title: this.$t('nothing not selected')
			},
			currentFilterValue: '',
			currentFilterFilterValue: '',
			filters: [],
			itemStructure: [],
			localization: {},
			languages: {},
			allAttributeGroupsName: [],
			unusedAttributeGroupsName: []
		}
	},
	computed: {
		filterData () {
			let self = this
			if (this.currentFilterValue !== undefined && this.currentFilterValue !== '') {
				return this.unusedAttributeGroupsName.filter(function (d) {
					return d.title.toLowerCase().indexOf(self.currentFilterValue) !== -1 || d.title.toLowerCase().indexOf(self.currentFilterValue) !== -1
				})
			} else {
				return this.unusedAttributeGroupsName
			}
		}
	},
	methods: {
		getConfiguration: function () {
			this.$store.dispatch(CONFIGURATIONS_ITEM_STRUCTURE)
				.then(() => {
					this.filters = this.$store.getters.getDbFilter || []
					this.itemStructure = this.$store.getters.getItemStructure
					this.languages = this.$store.getters.getLanguage
					this.allAttributeGroupsName = arrayKey(this.$store.getters.getItemStructure)
				})
				.then(() => {
          for (var key in this.itemStructure) {
						this.unusedAttributeGroupsName.push({
							'title': key,
							'localization': this.$t(this.itemStructure[key].title) || this.itemStructure[key].title,
						})
					}

					this.unusedAttributeGroupsName = this.unusedAttributeGroupsName.sort((a, b) => {
						if (a.localization > b.localization) {
							return 1
						}
						if (a.localization < b.localization) {
							return -1
						}
						return 0
					})
				})
				.catch(errors => {
					console.error(errors)
					this.rollbar.error('CONFIGURATIONS_ITEM_STRUCTURE', errors)
				})
		},
    saveTableFilter () {
      saveAttributes(this.filters, 'DB_FILTER_ATTRIBUTES')
    },
		clearFilter () {
			this.currentFilterValue = ''
		},
		clearFilterFilter () {
			this.currentFilterFilterValue = ''
		},
		isFilterVisible (filter) {
			if (this.currentFilterFilterValue !== undefined && this.currentFilterFilterValue !== '') {
				const searchLower = this.currentFilterFilterValue.toLowerCase()
				const localization = this.getFilterLocalization(filter).toLowerCase()
				return filter.toLowerCase().indexOf(searchLower) !== -1 || localization.indexOf(searchLower) !== -1
			}
			return true
		},
		getFilterLocalization (filter) {
			if (this.itemStructure[filter]) {
				return this.$t(this.itemStructure[filter].title) || this.itemStructure[filter].title || filter
			}
			return filter
		},
		handleDrop (data) {
      console.log('drop', data)
			let { index, list, item } = data
      let title = item.title
      let sliceIndex = index

      if (!title) {
        title = item
      }

      // Check if filter already exists
      let oldIndex = list.findIndex(filter => filter === title);
      if (oldIndex !== -1) {
        this.$delete(list, oldIndex);
      }

      if (oldIndex < index && !item.title) {
        sliceIndex = index - 1
      }

      // Add new filter
      list.splice(sliceIndex, 0, title)
		},
    handleMovedFilter (item) {
      console.log('moved filter', item)
    },
		handleMovedItemList (item) {
      console.log('moved item list', item)
		},
    handleDeleteFilter (filter) {
      const index = this.filters.findIndex(f => f === filter)
      if (index !== -1) {
        this.filters.splice(index, 1)
      }
      this.clearFilterFilter()
    },
		handleSelected (item) {
			this.selectedItem = item
		}
	},
	mounted() {
		this.getConfiguration()
		window.companyId = this.$store.getters.getProfile.companyId
	}
}
</script>

<style>
	h1, h2 {
		font-weight: 400
	}

	ul {
		list-style-type: none;
		padding: 0
	}

	#app {
		width: 100%;
    height: 90vh;
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		color: #2c3e50
	}

	.container {
		max-width: 980px;
		min-width: 730px;
		margin: 0 auto
	}

	.demo-content {
		width: 100%
	}

	.vddl-draggable, .vddl-list {
		position: relative;
		width: 100%;
	}

	.vddl-list {
		padding-left: 0;
		min-height: 40px
	}

	.vddl-dragging {
		opacity: .7
	}

	.vddl-dragging-source {
		display: none
	}

	.v-row {
		display: -ms-flexbox;
		display: flex;
		-ms-flex-pack: justify;
		justify-content: space-between;
		-ms-flex-wrap: wrap;
		flex-wrap: wrap;
		-ms-flex-align: start;
		align-items: flex-start
	}

	.v-row > [class*=v-col--] {
		box-sizing: border-box
	}

	.v-row .v-col--auto {
		width: 100%
	}

	.v-row .v-col--100 {
		width: 100%;
		width: calc((100% - 15px * 0) / 1)
	}

	.v-row.v-row--no-gutter .v-col--100 {
		width: 100%
	}

	.v-row .v-col--50 {
		width: 50%;
		width: calc((100% - 15px * 1) / 2)
	}

	.v-row.v-row--no-gutter .v-col--50 {
		width: 50%
	}

	.v-row .v-col--33 {
		width: 33.333333333333336%;
		width: calc((100% - 15px * 2) / 3)
	}

	.v-row.v-row--no-gutter .v-col--33 {
		width: 33.333333333333336%
	}

	.panel {
		border-radius: 0;
		border: 1px solid #ddd;
		overflow: hidden;
	}

	.panel p {
		display: inline-block;
		margin: 0
	}

	.panel__heading {
		height: 40px;
		line-height: 40px;
		border-bottom: 1px solid #ddd;
		background: #f5f5f5;
		position: relative;
	}

	.panel__heading h3 {
		font-size: 15px;
		padding: 9px 15px;
		margin: 0
	}

	.panel__body {
		background: #fff;
		min-height: 40px
	}

	.panel__body > .panel {
		margin: 10px
	}

	.panel__body p {
		width: 100%;
		padding: 0;
		font-size: 14px;
		color: #666
	}

	.panel--filter {
		font-size: 14px;
		line-height: 20px;
	}

	.panel--filter .panel__body--list {
		text-align: left;
	}

	.panel__body--list {
		background: #fff;
	}

	.panel__body--item, .panel__body .panel__placeholder {
		width: 100%;
		min-height: 40px;
		line-height: 25px;
		border-bottom: 1px solid #ddd;
		padding: 5px 15px;
		background: #fff;
		box-sizing: border-box;
	}

	.panel__body--item.no-padding-left {
		padding-left: 0
	}

	.panel__body--item:last-child {
		border-bottom: none
	}

	.panel__body--item > .panel {
		margin: 15px 0
	}

  .panel__body--item input {
    margin-right: 5px;
  }

	.panel .panel__placeholder {
		background: #f5f5f5
	}

  .panel__body--item:hover {
    cursor: move;
  }

	.panel.panel--info .panel__body {
		padding: 25px
	}

	.main {
		min-height: 350px;
		height: 100%;
	}

	.panel__body--list .vddl-placeholder {
		width: 100%;
	}

	.vddl-placeholder {
		width: 100%;
		min-height: 61px;
		border-bottom: 1px solid #ddd;
		padding: 0 15px;
		margin-bottom: 15px;
		background: #0090d01c
	}

	.new-elements .button {
		border: 1px solid #42b983;
		text-align: center;
		height: 40px;
		line-height: 40px;
		background-color: #42b983;
		color: #fff;
		cursor: move;
		font-size: 14px
	}

	.new-elements .vddl-dragging-source {
		display: block;
	}

	.selected {
		background: #0090d01c
	}

	.clear {
    position: absolute;
    transition: all .2s;
    top: -10px;
    right: 5%;
    font-size: 20px;
    font-weight: bold;
    background-color: white;
    margin: 0;
    padding: 0;
    height: 20px;
	}

	.clear:hover {
		cursor: pointer;
		color: #ff00008a;
	}

	.filter-control {
		width: 100%;
		margin: 15px 0;
	}

	.filter-control {
		margin: 15px;
    position: relative;
	}

	.filter-control input {
		width: 94%;
		height: 29px;
		padding: 0 5px;
		border-radius: 2px;
		border: 1px solid #ababab;
	}

	.filter-control input {
    border-radius: 0;
	}

  .filter-control input:focus {
    outline: none;
  }

  .filter .panel__body--list {
    max-height: 75vh;
  }

  .table-filter .scroll_panel__body {
    max-height: 75vh;
  }

  .new-elements .panel__body--list {
    max-height: 75vh;
  }

	.filter .panel__body--list, .table-filter .panel__body--list, .new-elements .panel__body--list {
		overflow-x: auto;
	}

	span {
		color: #6888a8;
	}

	.drag {
		color: #c1c1c1;
		margin: 0 10px 0 0;
	}

	.delete-icon {
		float: right;
		cursor: pointer;
		color: #ff0000;
		margin-top: 5px;
	}

	.delete-icon:hover {
		color: #cc0000;
	}
</style>
